import { makeAutoObservable, runInAction } from "mobx";
import { ExpeditionStatusResponse, PageableShipment, Shipment } from "../client";
import ShipmentRepository from "../data/repositories/ShipmentRepository";

export default class ShipmentViewModel {
  static instance: ShipmentViewModel;

  static getInstance(): ShipmentViewModel {
    if (ShipmentViewModel.instance === undefined) {
      ShipmentViewModel.instance = new ShipmentViewModel();
    }
    return ShipmentViewModel.instance;
  }

  private constructor() {
    makeAutoObservable(this);
    this.loadAdminShipments = this.loadAdminShipments.bind(this);
    this.setIsLoadingInTable = this.setIsLoadingInTable.bind(this);
  }

  loadingShipment: boolean = false;
  isLoadingInTable: boolean = false;
  currentShipment?: Shipment;
  currentShipmentResponse?: ExpeditionStatusResponse;
  //adminShipments: ExpeditionStatusResponse[] | null | undefined = undefined
  selectedRowIndex: number | undefined;
  shipmentsAdmin: Shipment[] | null | undefined = undefined;
  trackingAlb: string | undefined;
  trackingPhone: string | undefined;

  setIsLoadingInTable(val: boolean) {
    this.isLoadingInTable = val;
  }

  async refreshChatStatus() {
    console.log("Refreshing chat status for current shipment with exp:", this.currentShipment?.shipmentExp, "and phone:", this.currentShipment?.phone);
    if (this.currentShipment) {
      const expeditionStatusResponse = await ShipmentRepository.getStatusExpedition(
        this.trackingAlb || this.currentShipment.shipmentAlb || "",
        this.trackingPhone || this.currentShipment.phone || ""
      );
      runInAction(() => {
        this.currentShipment = expeditionStatusResponse.shipment;
        this.currentShipmentResponse = expeditionStatusResponse;
      });
    }
  }

  loadShipment(shipmentExp: string, phoneNumber: string) {
    console.log("Loading shipment with exp:", shipmentExp, "and phone:", phoneNumber);
    runInAction(() => (this.loadingShipment = true));
    return new Promise<ExpeditionStatusResponse>((resolve, reject) => {
      ShipmentRepository.getStatusExpedition(shipmentExp, phoneNumber)
        .then((res: ExpeditionStatusResponse) => {
          runInAction(() => (this.loadingShipment = false));
          if (res.shipment === undefined) runInAction(() => (this.currentShipment = undefined));
          else {
            runInAction(() => (this.currentShipmentResponse = res));
            runInAction(() => (this.currentShipment = res.shipment));
          }
          resolve(res);
        })
        .catch((error) => {
          console.log("Error loading shipment:", error, { shipmentExp, phoneNumber });
          runInAction(() => (this.loadingShipment = false));
          runInAction(() => (this.currentShipment = undefined));
          reject(error);
        });
    });
  }

  unLoadShipment() {
    console.log("Unloading current shipment");
    runInAction(() => {
      this.currentShipment = undefined;
      this.selectedRowIndex = undefined;
    });
  }

  setSelectedRowIndex(value: number | undefined) {
    this.selectedRowIndex = value;
  }

  unloadAdminShipments() {
    this.shipmentsAdmin = undefined;
  }

  loadAdminShipments(pageNum: number = 1, pageSize: number = 50, hideAlreadyRead: boolean = false): Promise<PageableShipment> {
    runInAction(() => {
      this.loadingShipment = true;
    });

    return new Promise((resolve, reject) =>
      ShipmentRepository.getAdminShipments(pageNum, pageSize, hideAlreadyRead)
        .then((res: PageableShipment) => {
          console.log("Admin shipments loaded successfully:", res);
          runInAction(() => {
            this.loadingShipment = false;
            if (res === undefined) {
              this.shipmentsAdmin = [];
            } else {
              this.shipmentsAdmin = res.items;
            }
          });
          resolve(res);
        })
        .catch((error) => {
          runInAction(() => (this.loadingShipment = false));
          runInAction(() => (this.shipmentsAdmin = undefined));
          console.error("Error loading admin shipments:", error, {
            pageNum,
            pageSize,
            hideAlreadyRead,
            pageNumType: typeof pageNum,
            pageSizeType: typeof pageSize,
            hideAlreadyReadType: typeof hideAlreadyRead,
          });
          reject(error);
        })
    );
  }

  searchAdminShipment(expRef: number): Promise<ExpeditionStatusResponse> {
    return new Promise((resolve, reject) =>
      ShipmentRepository.getStatusExpeditionByReference(expRef)
        .then((res: ExpeditionStatusResponse) => {
          runInAction(() => (this.loadingShipment = false));
          if (res === undefined || res.shipment === undefined) this.shipmentsAdmin = undefined;
          else this.shipmentsAdmin = [res.shipment!];
          resolve(res);
        })
        .catch((error) => {
          runInAction(() => (this.loadingShipment = false));
          this.shipmentsAdmin = undefined;
          reject(error);
        })
    );
  }

  filterExpeditionsByLastMessage(
    pageNum: number = 1,
    pageSize: number = 50,
    filterCheckHideAnswered: boolean = false
  ): Promise<PageableShipment> {
    return new Promise((resolve, reject) => {
      ShipmentRepository.filterExpeditionsByLastMessage(pageNum, pageSize, filterCheckHideAnswered)
        .then((response) => {
          runInAction(() => (this.loadingShipment = false));
          if (response === undefined || response.items?.length === 0) this.shipmentsAdmin = undefined;
          else this.shipmentsAdmin = response.items;
          resolve(response);
        })
        .catch((err) => {
          runInAction(() => (this.loadingShipment = false));
          runInAction(() => (this.shipmentsAdmin = undefined));
          reject(err);
        });
    });
  }

  setTrackingPhone(phone: string) {
    this.trackingPhone = phone;
  }
  setTrackingAlb(alb: string) {
    this.trackingAlb = alb;
  }
}
